import { Injectable, signal, inject, computed } from '@angular/core';
import { environment } from '@env/environment';

import { CipherService } from '../cipher/cipher.service';

import { Credentials, Usuario } from '@data/models';

@Injectable({
  providedIn: 'root',
})
export class CredentialsService {
  private cipherService = inject(CipherService);

  cambioPassword = signal<boolean>(true);

  private _credentials = signal<Credentials | null>(null);
  credentials = this._credentials.asReadonly();
  isAuthenticated = computed(() => !!this.credentials());

  private _usuario = signal<Partial<Usuario> | null>(null);
  readonly usuario = computed<Partial<Usuario> | null>(() => this._usuario());

  constructor() {
    const savedCredentials = localStorage.getItem(environment.credentialsKey);
    // console.log('savedCredentials', savedCredentials);
    if (savedCredentials) {
      try {
        const userInfo = JSON.parse(this.cipherService.get(environment.oauthStorageKey, savedCredentials));
        this._credentials.set(userInfo);
      } catch {
        this.setCredentials();
      }

      // console.log('123', this.cipherService.get(environment.oauthStorageKey, savedCredentials));
      // const userInfo = JSON.parse(this.cipherService.get(environment.oauthStorageKey, savedCredentials));
      // this._credentials.set(userInfo);
    }
  }

  setUsuario(usuario?: Partial<Usuario>) {
    this._usuario.set(usuario || null);
  }

  setCredentials(credentials?: Credentials) {
    this._credentials.set(credentials || null);

    if (!credentials) {
      return localStorage.clear();
    }

    const credentialsEncrypt = this.cipherService.set(environment.oauthStorageKey, JSON.stringify(credentials));
    localStorage.setItem(environment.credentialsKey, credentialsEncrypt);
  }
}
